import { Table } from 'components/table'
import { ICustomConnectorDTO } from 'data/dtos/automation/i-custom-connector-dto'
import { ITableHeadDTO } from 'data/dtos/components/i-table-head-dto'
import React, { ChangeEvent, MouseEvent, useEffect, useState } from 'react'
import api from 'services/api'
import { useAlreadyMounted } from 'utils/use-already-mounted'
import { useStyles } from './styles'

const headCells: ITableHeadDTO[] = [
  {
    id: 'connectorTypeName',
    label: 'Tipo de Conector',
    width: 3,
    type: 'text',
  },
  {
    id: 'connectorName',
    label: 'Nome do conector',
    width: 4,
    type: 'text',
  },
]

const CustomConnectorList: React.FC = () => {
  const [page, setPage] = useState<number>(0)
  const [search, setSearch] = useState<string>('')
  const [rowsCount, setRowsCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [rowsPerPage, setRowsPerPage] = useState<number>(100)
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false)
  const [columnOrder, setColumnOrder] = useState<('ASC' | 'DESC')[]>([])
  const [recordToDelete, setRecordToDelete] = useState<string | null>('')
  const [orderByDirection, setOrderByDirection] = useState<boolean>(true)
  const [customConnectorsList, setCustomConnectorsList] = useState<ICustomConnectorDTO[]>([])

  const classes = useStyles()
  const alreadyMounted = useAlreadyMounted()

  const loadCustomConnectors = async (isSearch?: boolean) => {
    if (!isSearch) {
      setIsLoading(true)
    }

    await api
      .post('/custom-connectors/list', { search, page, rowsPerPage, columnOrder })
      .then((response) => setCustomConnectorsList(response.data.data))
      .catch((error) => {
        setIsLoading(false)
        console.log(error)
      })

    await api
      .post('/custom-connectors/count', { search })
      .then((response) => setRowsCount(response.data.data.count))
      .catch((error) => {
        setIsLoading(false)
        console.log(error)
      })

    setIsLoading(false)
  }

  const handleDelete = async () => {
    await api
      .delete(`/custom-connectors/${recordToDelete}`)
      .then(async () => await loadCustomConnectors())
      .catch((error) => console.log(error.response?.data))
  }

  const searchChange = (value: string) => {
    setSearch(value)
  }

  const handleClose = () => {
    setModalIsOpen(false)
  }

  const handleChangePage = (event: MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    event!.preventDefault()
    setPage(newPage)
  }

  const handleChangeRowsPerPage = async (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleCloseDelete = () => {
    setModalIsOpen(false)
    handleDelete()
  }

  const handleDeleteButton = (e: MouseEvent<any, any>, id: string) => {
    e.stopPropagation()
    setModalIsOpen(true)
    setRecordToDelete(id)
  }

  const handleSortChange = (index: number) => {
    columnOrder[index] = columnOrder[index] === 'ASC' ? 'DESC' : 'ASC'

    setColumnOrder(columnOrder)
    setOrderByDirection(!orderByDirection)
  }

  const tabOptions = [
    {
      title: 'Todas',
      size: rowsCount,
      handleClick: () => {},
    },
  ]

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!alreadyMounted) {
        loadCustomConnectors()
      }
    }, 1000)

    return () => clearTimeout(timeout)
  }, [search])

  useEffect(() => {
    loadCustomConnectors()
  }, [orderByDirection, rowsPerPage, page])

  return (
    <Table.Root>
      <Table.Info
        title='Conectores Customizados'
        route='/custom-connectors/new'
        subTitle='Dados sobre os conectores de uso por todos.'
      />

      <Table.tabs options={tabOptions} />
      <Table.SearchBar
        value={search}
        handleChange={searchChange}
      />

      <Table.Overlay
        isEmpty={customConnectorsList.length <= 0}
        isSearch={search.length > 0}
        isLoading={isLoading}
        route='/custom-connectors/new'
        emptyRouteText='Adicionar custom_connector'
        searchRouteText='Adicionar custom_connector'
        searchMessage='Nenhum custom_connector encontrado, você pode criar um novo custom_connector clicando no botão'
        emptyMessage='Seja bem-vindo à página de gerenciamento de CustomConnectorss. Até o momento, nenhum custom_connector foi criado. Para começar, você pode criar um novo custom_connector clicando no botão'
      >
        <Table.Wrapper
          totalRows={rowsCount}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          page={page}
          handleClose={handleClose}
          handleCloseDelete={handleCloseDelete}
          modalIsOpen={modalIsOpen}
        >
          <Table.Header
            handleSortChange={handleSortChange}
            setOrder={setColumnOrder}
            headCells={headCells}
            order={columnOrder}
          />
          <Table.Body
            handleDeleteButton={handleDeleteButton}
            editRoutePath='/custom-connectors/edit'
            headCells={headCells}
            rows={customConnectorsList}
          />
        </Table.Wrapper>
      </Table.Overlay>
    </Table.Root>
  )
}

export default CustomConnectorList
